import { IListElementCellBase } from './list-element-cell-base.interface';
import { IListElementCell } from './list-element-cell.interface';

import { TStringBool } from '../../tstring-bool.type';

export interface IListElementImgCell extends IListElementCellBase {
  $spritesvg: TStringBool;
  $img: string;
}

/**
 * Check cell on img type
 *
 * @param cell
 */
export function isImgCell(cell: IListElementCell): cell is IListElementImgCell {
  return '$img' in cell || '$spritesvg' in cell;
}
